import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { NAP } from "@/lib/nap";

// Pre-compute the bare digits once at module scope so the wa.me deep-link
// does not re-allocate on every render.
const PHONE_DIGITS = NAP.phone.replace(/[^0-9]/g, "");
const CALL_HREF = `tel:${NAP.phone}`;
const WHATSAPP_HREF = `https://wa.me/${PHONE_DIGITS}?text=${encodeURIComponent(
  "Hello Siddhivinayak Group, I'd like to enquire about your projects in Nagpur."
)}`;

const FloatingContact = () => (
  <div className="ltn__floating-contact" aria-label="Quick contact actions">
    <a
      className="ltn__floating-contact__btn ltn__floating-contact__btn--call"
      href={CALL_HREF}
      title={`Call ${NAP.phoneDisplay}`}
      aria-label={`Call ${NAP.phoneDisplay}`}
    >
      <FaPhoneAlt />
    </a>
    <a
      className="ltn__floating-contact__btn ltn__floating-contact__btn--whatsapp"
      href={WHATSAPP_HREF}
      target="_blank"
      rel="noopener noreferrer"
      title="Chat on WhatsApp"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp />
    </a>
  </div>
);

export default FloatingContact;
